// Identidade das entidades: UUID v4 gerado no cliente (ADR-0003).

/** Um identificador de entidade. Sempre um UUID v4 em minúsculas. */
export type Id = string;

const V4 =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

/** Gera um novo Id (UUID v4). */
export function newId(): Id {
  return crypto.randomUUID();
}

/** Verdadeiro se `value` tem a forma de um UUID v4. */
export function isId(value: unknown): value is Id {
  return typeof value === "string" && V4.test(value);
}
